import React from 'react'
import HeaderTwo from '../../../common/header/HeaderTwo';
import FooterOne from '../../../common/footer/FooterOne';
import AURAAgents from '../../../components/products/aura-agentic-ai/AURAAgents';

const AURAAgent = () => {
  return (
    <>
      <HeaderTwo styles="header-transparent header-style-2" searchDisable />
      <AURAAgents />
      <FooterOne />
    </>
  )
}

export default AURAAgent;